<div class="uk-section">
  <div class="switch-view-container">
    <img class="uk-align-center pnf-logo" src="assets/images/deck_RGB.svg" alt="Dealflow logo" />

    <p class="uk-text-lead uk-text-bold uk-text-center">
      <ng-container i18n="@@oopsTry">Oops. Something went wrong. Try again or </ng-container>
      <a routerLink="/" i18n="@@goToFrontPage">go to the front page.</a>
    </p>
  </div>
</div>
